import React from 'react';
import renderHTML from 'react-render-html';
import { range } from 'd3-array';
import { areas, colors, wordArticles, prettyNames } from '../../utils';
import {
  NeutralFaceDef,
  PositiveFaceDef,
  NegativeFaceDef
} from "../Bubbles/emoticons.js";
import './visualtimeline.css';

const VisualTimeline = (props) => {

  if(!props.slugsSortedList.length) {
    return null;
  }

  //const firstArea = props.slugsSortedList[0][0];
  //const secondArea = props.slugsSortedList[1][0];
  // const selectedAreas = areas.filter(d => (d !== firstArea && d !== secondArea));
  let prevY = -10000;

  const texts = props.texts.map(d => {
    const classNames = d.className || '';
    const y = (d.y - prevY > 350) ? d.y : d.y + 350;
    prevY = y;

    if(d.data) {
      let mostDiscussed = '';
      let highestDiscussion = 0;
      Object.entries(d.data).forEach(slug => {
        if(slug[1] > highestDiscussion) {
          mostDiscussed = slug[0];
          highestDiscussion = slug[1];
        }
      })

      return <li key={d.id} className={classNames} style={{top:`${y}px`}}>
        <span>{renderHTML(d.text)}</span>
        <span>L'area politica pi&ugrave; discussa &egrave; stata {wordArticles[mostDiscussed]} <span className="party-name"
          style={{ borderColor: colors[mostDiscussed] }}>{prettyNames[mostDiscussed]}</span></span>
        <DiamondsChart data={d.data} />
        <EmoticonsStats data={d.sentiments} />
      </li>;
    }
    return <li key={d.id} style={{top:`${y}px`}} className={classNames}><span>{renderHTML(d.text)}</span></li>;
  })

  return <section id="visualTimeline" className="contents-overlay parallax-layer parallax-layer-back">
    <ul className="visual-timeline">
      {texts}
    </ul>
  </section>
}

const DiamondsChart = (props) => {
  let diamonds = [];
  Object.entries(props.data).forEach((slug,i) => {
      diamonds = [...diamonds, ...range(slug[1]).map((d,i) => ({index:`${diamonds.length}_${i}`, slug: slug[0]}))].sort((a, b) => areas.indexOf(a.slug) - areas.indexOf(b.slug));
  })
  return <ul className="diamond-chart">
    {diamonds.map((d,i) => <li key={d.index} style={{backgroundColor:colors[d.slug]}}>{d.slug}</li>)}
  </ul>;
}

const EmoticonsStats = (props) => {
  if(!props.data) {
    return null;
  }
  const emoticons = {
    '-1': {
      name: 'negativo',
      component: <NegativeFaceDef/>
    },
    '0': {
      name: 'neutrale',
      component: <NeutralFaceDef/>
    },
    '1': {
      name: 'positivo',
      component: <PositiveFaceDef/>
    },
    '-9': {
      name: 'neutrale',
      component: <NeutralFaceDef/>
    }
  }
  const sentiments = Object.entries(props.data).sort((a,b) => b[1] - b[0]);
  const highestSentiment = sentiments[0][1];
  const mostSentiments = sentiments.filter(d => d[1] === highestSentiment).map(d => `<b>${emoticons[d[0]].name}</b>`);

  return <div className="emoticons-stats">
    {mostSentiments.length>1?'I toni':'Il tono'} pi&ugrave; ricorrent{mostSentiments.length>1?'i':'e'} tra tutti questi articoli {mostSentiments.length>1?'sono':renderHTML('&egrave; il')} <span>{renderHTML(mostSentiments.join(mostSentiments.length === 2 ? ' e ' : ', '))}</span>:
    {sentiments.map(d => {
      return <div key={d[0]}>
        <svg height="42" width="43">
          <g transform="scale(1) translate(0,9)">
            {emoticons[d[0]].component}
          </g>
        </svg>
        <span className="stats-value">{d[1]} <i>articoli</i></span>
      </div>;
    })}
    {/* <div>
      <svg height="42" width="43">
        <g transform="scale(1) translate(0,9)">
      <PositiveFaceDef />
        </g>
      </svg>
      <span className="stats-value">23 articoli</span>
      </div>
      <div>
      <svg height="42" width="43">
        <g transform="scale(1) translate(0,10)">
      <NegativeFaceDef />
        </g>
      </svg>
      <span className="stats-value">23</span>
      </div>
      <div>
      <svg height="42" width="43">
        <g transform="scale(1) translate(0,10)">
      <NeutralFaceDef />
        </g>
      </svg>
      <span className="stats-value">23</span>
    </div> */}
  </div>;
}

export default VisualTimeline;



// WEBPACK FOOTER //
// ./src/elezioni/components/Layout/VisualTimeline.js